module.exports = {
      id: "moeda-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#moeda",
      toString: function () {
        return this.url;
      }
    }